import { makeCommonStore, FormField } from '../commons'
import EntityService from '@/services/EntityService.js'

const store = {
  ...makeCommonStore(
    {
      service: EntityService,
      requiredFields: [
        new FormField({
          name: 'name',
          label: 'Entity name *',
          rules: [ 'required' ],
          icon: 'assignment_turned_in',
          value: '',
          md: 6
        }),
        new FormField({
          name: 'ird',
          type: 'mask',
          label: 'IRD * (123-456-789)',
          rules: [ 'required' ],
          icon: 'style',
          mask: '###-###-###',
          value: '',
          md: 6
        }),
        new FormField({
          name: 'email',
          label: 'Email *',
          rules: [ 'required' ],
          icon: 'email',
          value: '',
          md: 6
        }),
        new FormField({
          name: 'entity_type',
          type: 'select',
          label: 'Entity Type *',
          icon: 'work_outline',
          rules: [ 'required' ],
          value: null,
          items: [],
          md: 6
        })
      ],
      fields: [
        new FormField({
          name: 'id',
          hidden: true
        }),
        new FormField({
          name: 'signature',
          hidden: true
        }),
        new FormField({
          name: 'name',
          label: 'Entity name *',
          rules: [ 'required' ],
          icon: 'assignment_turned_in',
          md: 12
        }),
        new FormField({
          name: 'ird',
          type: 'mask',
          label: 'IRD *',
          rules: [ 'required' ],
          icon: 'style',
          mask: '###-###-###'
        }),
        new FormField({
          name: 'email',
          label: 'Email *',
          rules: [ 'required' ],
          icon: 'email'
        }),
        new FormField({
          name: 'gst_registered',
          hidden: true,
          type: 'radio',
          label: 'GST registered',
          items: [ 'Yes', 'No' ],
          rules: [ 'required' ],
          md: 12
        }),
        new FormField({
          name: 'address',
          type: 'address',
          rules: [ 'required' ],
          label: 'Business address *',
          md: 12
        }),
        new FormField({
          name: 'mailing_address',
          type: 'address',
          label: 'Mailing address',
          md: 12
        }),
        new FormField({
          name: 'trade_name',
          label: 'Trade name',
          icon: 'work_outline',
          md: 6
        }),
        new FormField({
          name: 'entity_type',
          type: 'select',
          label: 'Entity Type *',
          rules: [ 'required' ],
          icon: 'work_outline',
          items: [],
          md: 6
        }),
        new FormField({
          name: 'business_activity',
          label: 'Business activity',
          icon: 'device_hub',
          md: 12
        }),
        new FormField({
          name: 'is_lookthrough',
          type: 'checkbox',
          label: 'Is lookthrough?',
          md: 4,
          hidden: true
        }),
        new FormField({
          name: 'filling_allowed',
          type: 'checkbox',
          label: 'Filling allowed',
          md: 4,
          hidden: true
        }),
        new FormField({
          name: 'company_key',
          label: 'Company key',
          md: 12,
          hidden: true
        }),
        new FormField({
          name: 'invoice_notes',
          type: 'textarea',
          label: 'Invoice notes',
          placeholder: 'Please make payment to the following account:\nBusiness bank account number: 00-0000-0000000-00\nPlease include invoice',
          md: 12
        })
      ]
    },
    ['fields']
  ),
  namespaced: true
}

export default store
